// extracted by mini-css-extract-plugin
export default {"wrap":"JH-z","subtitle":"KH-z","contentWrap":"LH-z","imgWrap":"MH-z","heading":"NH-z","copy":"OH-z"};